<div class="dropdown-menu shadow dropdown-menu-right animated--grow-in show">
  <a
    class="dropdown-item"
    href="#"
    [routerLink]="'my-account/my-infos'"
    (click)="closeMenu()"
  >
    <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"> </i>&nbsp;Mon compte
  </a>
  <div class="dropdown-divider"></div>
  <a
    class="dropdown-item"
    href="#"
    [routerLink]="'my-connectors'"
    (click)="closeMenu()"
  >
    <i class="fas fa-plug fa-sm fa-fw mr-2 text-gray-400"> </i>&nbsp;Mes
    connecteurs
  </a>
  <div class="dropdown-divider"></div>
  <div class="dropdown-item" (click)="logout()" style="cursor: pointer">
    <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"> </i>Me
    déconnecter
  </div>
</div>
